import { Button } from "antd"
import { useApplyCustomerDisplayAsMutation } from "./tenantsQueries"

export type Props = {
  disabled?: boolean
}

const ApplyCustomerDisplayAsButton = ({ disabled }: Props) => {
  const applyCustomerDisplayAs = useApplyCustomerDisplayAsMutation()
  return <Button type="primary" onClick={()=>applyCustomerDisplayAs.mutate()} disabled={disabled}>Apply Display As to All Customers</Button>
}

export default ApplyCustomerDisplayAsButton